var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"customButton",attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.clickAction}},[(_vm.leftIcon)?_c('span',{staticClass:"icon"},[_vm._v(_vm._s(_vm.leftIcon))]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.buttonTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }